module.exports = __webpack_public_path__ + "img/car_inactive.ac89d388.svg";